window.W = require('exports-loader?exports=W!@wix/wix-bi-logger/dist/scripts/bi-logger/wix-bi-angular').W;
require('@wix/wix-angular/dist/wix-angular');
require('../scripts/landingInvalid');
require('./partials/bi-log');
